import { axios } from '@Root/API'

export const get = (id, page) => {
  return axios.get(`applications/${id}/attachment/history`, {
    params: {
      page,
    },
  })
}
